import React, { useCallback, useContext, useEffect, useState } from "react";
import { GET_DASHBOARD_TOP_CONTAINERS } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import { Card, CardHeader } from "@mui/material";
import { genericPost } from "../../services/authServices";
import { Box, LinearProgress, Typography } from "@mui/material";
import { t } from "../../constants/translationHelper";

function LinearBufferWithLabel({ value }) {
    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                border: "1px solid #0058CD",
                borderRadius: "8px",
                overflow: "hidden",
            }}
        >
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    height: 15,
                    backgroundColor: "#FFFFFF",
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: "#0058CD",
                    },
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography
                    sx={{
                        fontSize: "11px",
                        fontWeight: 600,
                        color: value > 50 ? "#FFFFFF" : "#0058CD",
                    }}
                >
                    {`${value.toFixed(2)}%`}
                </Typography>
            </Box>
        </Box>

    );
}

const TopImportContainerChart = () => {
    const [topContainers, setTopContainers] = useState([]);
    const { token } = useContext(AuthContext);
    const fetchData = useCallback(async () => {
        try {
            const payload = { commanShipmentId: 0 };
            const response = await genericPost(GET_DASHBOARD_TOP_CONTAINERS, payload);

            if (response.data.success && response.data.topContainers) {
                setTopContainers(response.data.topContainers);
            }
        } catch (error) {
            console.error("Error fetching Import data", error);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData, token]);

    const totalSum = topContainers.reduce(
        (sum, item) => sum + Number(item.totalContainers || 0),
        0
    );
    const highestBase = totalSum || 0;


    const headerStyle = {
        padding: "10px",
        borderBottom: "2px solid #ddd",
        fontSize: "12px",
        fontWeight: "700",
        color: "#000000",
    };

    return (
        <Card style={{
            padding: "0px", backgroundColor: "#F4FDFF", boxShadow: "none", color: "#000000",
        }}>
            <CardHeader title={t("Top Import Container")} titleTypographyProps={{
                fontWeight: 700,
                fontSize: "16px"
            }}
            />
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                }}
            >
                <thead>
                    <tr style={{ background: "#DEF8FE", }}>
                        <th style={headerStyle}>{t("Company Name")}</th>
                        <th style={headerStyle}>{t("Containers")}</th>
                        <th style={headerStyle}>{t("Trend")}</th>
                        <th style={headerStyle}>{t("Progress")}</th>
                    </tr>
                </thead>
                <tbody>
                    {topContainers.length > 0 ? (
                        topContainers.map((row, index) => {
                            const percentage =
                                highestBase > 0
                                    ? (Number(row.totalContainers) * 100) / highestBase
                                    : 0;
                            return (
                                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "5px", fontSize: "12px" }}>
                                        {row.clientCompany?.clientCompanyName}
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px" }}>
                                        {row.totalContainers}
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px" }}>
                                        {highestBase > 0
                                            ? ((Number(row.totalContainers) * 100) / highestBase).toFixed(2) + " %"
                                            : "0 %"}
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", minWidth: "150px" }}>
                                        <LinearBufferWithLabel value={percentage} />
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" style={{ padding: "10px", textAlign: "center" }}>
                                {t("No data available")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </Card>
    );
};

export default TopImportContainerChart;
